export interface IAuctionEvent {
    id?: number;
    event: AuctionEventType;
    payload?: any;
}

export enum AuctionEventType {
    AuctionUpdated,
    AuctionDeleted,
    AuctionEndChanged,
    ItemAdded,
    ItemUpdated,
    NewMessage,
    NewBroadcast,
    BidAdded,
    BidDeleted,
    WinStateChanged,
    SponsorUpdated,
    NoAuction,
    PreAuthComplete,
    PaymentComplete,
    TestPaymentComplete
}

export interface ITutorial {
    tutorialId: number;
    page: string;
    isAdmin: boolean;
    elementId: string;
    text: string;
    textPosition: number;
}

export enum AddonType
{
    Features = 0,
    Items = 1,
    Pictures = 2,
    Guests = 3,
    Admins = 4,
}

export interface IStripeAccount {
    email: string;
    id: string;
    onboardingLink: string;
}

export interface ISku {
    code?: string;
    name?: string;
    description?: string;
    currency?: string;
    cost: number;
    costCdn: number;
    isBundle?: boolean;
    sponsors: boolean;
    products: number;
    users: number;
    images: number;
    support: boolean;
    branding: boolean;
    saleStart?: Date;
    saleEnd?: Date;
    removeArcBanner: boolean;
    saleCost?: number;
    enableOnlinePayments: boolean;
    enableStripeConnect: boolean;
    enableExtendedAuction: boolean;
    enableTicketing: boolean;
    raffleTickets?: number;
    webOnly?: boolean;
    isBulkBundle?: boolean;
    admins: number;
    enableItemVideo: boolean;
    addonType: AddonType;

    // Not from API
    qty: number;
    featureStatus?: number; //1 = feature in cart, 2 = feature on auction
    promoted?: boolean;
    meetsEstimates?: boolean;
    isFeature?: boolean;
    costWTax: number;
    showBundleDetails?: boolean;
}

export interface IPurchase {
    cart: IPurchaseSku[];
    province: number;
    transactionId: string;
    platform: string;
    currency: string;
    auctionId: number;
    voucherTotalOwed?: number;
}

export interface IPurchaseSku {
    code: string;
    quantity: number;
}

export interface IConfig {
    serverTime: string;
    versionState: number;
    message: string;
}

export interface IBidAlertInput {
    name: string;
    type: any;
    min: number;
    value: string;
}
